export * from './phrases-selector';

/*** Константы для кампаний ***/

export const MINUTES_PER_HOUR = 60;
export const HOURS_PER_DAY = 24;
export const DAYS_PER_WEEK = 7;
export const MOSCOW_TIME_ZONE = 3;
export const MIN_COUNT_WORKING_DAYS = 40;
export const NUMBER_LAST_WORKING_DAY = 5;

/*** Константы для групп ***/

export const MAX_SMART_GROUP_FILTERS_COUNT = 50;

/*** Константы для объявлений ***/

// вынести запрос констант
export const INTERNAL_BANNERS_IN_GROUP_LIMIT = 1000;
export const INTERNAL_BANNERS_IN_CAMPAIGN_LIMIT = 50000;

// константы для редактирования баннеров
export const BANNERS_IN_GROUP_LIMIT = 50;
export const BANNERS_IN_CAMPAIGN_LIMIT = Infinity;
export const DEFAULT_SITELINKS_COUNT = 4;
export const EXTENDED_SITELINKS_COUNT = 8;
export const SUMMARY_SITELINKS_TITLE_LENGTH = 66;
export const SUMMARY_MAX_LENGTH_CALLOUT_TITLE = 66;
export const SITELINK_TITLE_LENGTH = 30;
export const SITELINK_DESCR_LENGTH = 60;
export const PREDICT_REFUSAL_COUNT = 30;
export const TURBO_GALLERY_HREF_MAX_LENGTH = 1000;
export const TEXT_BANNER_BODY_DEFAULT_MAX_LENGTH = 81;

// константы для баннеров продвижения контента
// дефолтные размеры изображений в превью баннеров
export const CONTENT_PROMOTION_PREVIEW_DEFAULT_HEIGHT = 90;
export const CONTENT_PROMOTION_PREVIEW_DEFAULT_WIDTH = 120;
// ограничение по количеству символов редактируемых строковых полей
export const CONTENT_PROMOTION_TEXT_FIELD_MAX_LENGTH = 200;
// другое
export const INVALID_CONTENT_PROMOTION_ID = -1;
export const MIN_CARDS_IN_COLLECTION = 10;

// константы для редактирования медийных баннеров
export const ADDITIONAL_SHOW_COUNTERS_LENGTH = 3;

// константы для серпового превью баннера
export const TITLE_SENTENCE_SEPARATOR_FOR_BANNER_PREVIEW_DASH = ' – ';
export const TITLE_SENTENCE_SEPARATOR_FOR_BANNER_PREVIEW_SLASH = ' / ';
export const BANNER_PREVIEW_SERP_TITLE_PX_LIMIT = 517;

// константы для прайсовых пакетов
export const PRICE_PACKAGE_CPM_LIMIT = 1000000;
export const PRICE_PACKAGE_SHOWS_LIMIT = 2000000000;

/*** Константы без раздела ***/

// Константы  для маски инпута с вводом цены
export const PRICE_INPUT_MASK_SETTINGS = {
    mask: Number,
    scale: 2,
    signed: false,
    thousandsSeparator: ' ',
    padFractionalZeros: true,
    normalizeZeros: true,
    radix: ',',
    mapToRadix: ['.']
};

export const INTEGER_INPUT_MASK_SETTINGS = {
    mask: Number,
    scale: 0,
    signed: false,
    thousandsSeparator: ' ',
    normalizeZeros: true
};

export const ID_INPUT_MASK_SETTINGS = {
    mask: Number,
    scale: 0,
    signed: false
};

// Константы  для маски инпута с вводом цены
export const SIGNED_FLOAT_INPUT_MASK_SETTINGS = {
    mask: Number,
    scale: 3,
    signed: true,
    thousandsSeparator: ' ',
    normalizeZeros: true
};

// константы для корректировок ставок
export const RATE_CORRECTION_SWITCH_OFF_VALUE = -100;
export const RATE_CORRECTION_DEFAULT_VALUE = 100;

// константы для работы с api
export const MAX_ENTITIES_NUMBER_FROM_API = 10000;

// константы для смартов
export const SPECIAL_CREATIVE_GROUP_ID_FOR_GROUP_WITHOUT_ID = '0';
export const DEFAULT_CREATIVES_LIMIT = 500;
export const DEFAULT_CREATIVES_OFFSET = 0;

// константы для редиктирования интересов (профиль пользователей)
export const INTEREST_TARGETING_SETS_LIMIT = 3;
export const INTEREST_TARGETING_SELECT_IN_SET_LIMIT = 10;

// константы для (outdoor | indoor) превью выбранных щитов
export const INDOOR_OUTDOOR_PREVIEW_ADDRESS_LENGTH = 70;

// Константы для key codes
export const BACKSPACE_KEY = 'Backspace';
export const ENTER_KEY = 'Enter';
export const COMMA_KEY = ',';
export const ESC_KEY = 'Escape';
export const LEGACY_SPACE_KEY = 'spacebar';
export const SPACE_KEY = ' ';

// Константы для штучных Behaviors (признаков поведение) чтобы не получать их с бэка
export const BEHAVIORS_LTV = '2499000201';

// Константы для приоритета группы
export const GROUP_PRIORITY = {
    DEFAULT: '0',
    SPECIFIC: '10'
};
